export default __webpack_public_path__ + "static/media/logo.dd680600.svg";